import { useEffect, useState } from "react";
import { Rocket } from "lucide-react";
import { useApi } from "@/lib/api";
import { useMe } from "@/context/MeContext";

// Admin-only: how many robot setups have been sent to a hub and started.
export const RunCounter = () => {
  const { me } = useMe();
  const api = useApi();
  const [count, setCount] = useState(null);
  const isAdmin = me?.role === "admin";

  useEffect(() => {
    if (isAdmin) api.get("/stats/runs").then((r) => setCount(r.count)).catch(() => setCount(null));
  }, [api, isAdmin]);

  if (!isAdmin || count === null) return null;
  return (
    <div className="border-b bg-secondary/60" data-testid="admin-run-counter">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-x-3 gap-y-1 px-4 py-2.5 text-sm sm:px-8">
        <Rocket className="h-4 w-4 text-primary" />
        <p className="text-secondary-foreground">
          <b className="font-display text-base font-extrabold tabular-nums" data-testid="admin-run-count">{count.toLocaleString("en-AU")}</b>{" "}
          {count === 1 ? "project" : "projects"} powered by HubPilot so far
        </p>
        <span className="rounded-full border border-primary/30 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-primary">Only admins see this</span>
      </div>
    </div>
  );
};
